export const DATA_TEST_IDS = {
  letterNavigationButton: 'letter_navigation_button',
  userBagsContainer: 'user_bags_container',
  filtersForm: {
    button: 'filters_form_button',
    input: 'filters_form_input',
  },
};
